import { render } from "./ImportMappingStep.vue?vue&type=template&id=64df410e&scoped=true"
import script from "./ImportMappingStep.vue?vue&type=script&lang=js"
export * from "./ImportMappingStep.vue?vue&type=script&lang=js"

import "./ImportMappingStep.vue?vue&type=style&index=0&id=64df410e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64df410e"]])

export default __exports__